/**
 * Created by dejunliu on 2020/5/7.
 */

module.exports = {
  home:{
    'RespiratoryProtection' : 'Respiratory Protection',
    'DisposableProtectiveMask' : 'Disposable Protective Mask',
  },
}



// WEBPACK FOOTER //
// ./src/assets/i18n/en.js